<template>
  <v-card outlined :loading="loading">
    <v-card-title>
      ANULACIONES
      <v-spacer/>
      <v-btn
          color="primary"
          @click="openAnulacion('ConsumoAgua')"
      >
        + Anular factura de consumo de agua
      </v-btn>
      <v-btn
          color="accent"
          class="ml-2"
          @click="openAnulacion('OtroServicio')"
      >
        + Anular factura de otros ingresos
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <span>Anulaciones realizadas el día de <strong>hoy</strong></span>
      <v-btn
          color="secundary"
          class="ml-2"
          outlined
          title="Actualizar lista"
          @click="listar()"
      >
        <v-icon>mdi-update</v-icon>
      </v-btn>

      <v-data-table
          :headers="headers"
          :items="anulaciones"
          class="mt-5"
          hide-default-footer
          disable-pagination
      >
        <template v-slot:item.numero="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.factura="props">
          Nro. Factura: {{ props.item.numero_factura }} <br>
          nFac: {{ props.item.nfac }}
        </template>
        <template v-slot:item.fecha="props">
          {{ props.item.fecha | localDate }}
        </template>
        <template v-slot:item.cliente="props">
          <div>
            Cuenta: {{ props.item.cuenta }} <br>
            Ci/Nit:{{ props.item.ci_nit }}<br>
            Razón Social: {{ props.item.razon_social }}
          </div>
        </template>
        <template v-slot:item.estado>
          <span style="color: darkred">
          ANULADO
            </span>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="isNewDialog" persistent max-width="400px">
      <anulacion-form
          :tipo-anulacion="tipoAnulacion"
          @close="closeAnulacion()"
      />
    </v-dialog>
  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {anulacionStore} from "@/store/anulacionStore";
import {AnulacionService} from "@/services/AnulacionService";
import AnulacionForm from "@/views/anulaciones/AnulacionForm.vue";

@Component({
  name: "AnulacionIndex",
  components: {AnulacionForm}
})
export default class AnulacionIndex extends Vue {
  private anulacionStore = anulacionStore();
  private anulacionService = AnulacionService.getInstance();

  private tipoAnulacion = '';

  private headers = [
    {text: "#", value: "numero"},
    {text: "Fecha", value: "fecha"},
    {text: "Factura", value: "factura"},
    {text: "Cliente", value: "cliente"},
    {text: "Motivo", value: "motivo_anulacion"},
    {text: "Tipo", value: "tipo"},
    {text: "Estado", value: "estado"},
  ]

  get loading(): boolean {
    return this.anulacionStore.loading;
  }

  get anulaciones(): any[] {
    return this.anulacionStore.anulaciones;
  }

  get isNewDialog(): boolean {
    return this.anulacionStore.isNewDialog;
  }

  mounted() {
    this.listar();
  }

  listar() {
    this.anulacionService.index();
  }

  openAnulacion(tipo: string) {
    this.tipoAnulacion = tipo;
    this.anulacionStore.isNewDialog = true;
  }

  closeAnulacion() {
    this.anulacionStore.isNewDialog = false;
  }
}
</script>

<style scoped>

</style>